"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExercicesManager = void 0;
var utils_1 = require("./utils");
/**
 * It will be the class that select the next exercice for each AI
 * @param ontology : the ontology related to the AI algorithm we want to sample for (maybe it is better to have it as a parameter for each function in case two AI algorithm have different ontology ?)

 */
var ExercicesManager = /** @class */ (function () {
    function ExercicesManager() {
        this.history = {};
        this.history["AI"] = new utils_1.DefaultDict(Array);
        this.history["initialTest"] = [];
    }
    /**
     * checks if all the exercice in an activity have been seen by the student, if so it empties the history
     * @param actID : activity in which we want to sample an exercice
     * @param history : history for this activity in the AI (need to be inside the exerciceManager ?)
     * @param ontology : specify from which ontology to sample from
     * @returns : True if all the exercices have been seen by the student
     */
    ExercicesManager.prototype.check_if_history_full = function (actID, history, ontology) {
        return history.length >= ontology.exercices_in_act[actID].length;
    };
    /**
     * main function to be called to get a new exercice
     * @param algo : specify for which algo we want to sample. All the algos dont always have the same sampling strategy
     * @param actID : activity in which we want to sample an exercice
     * @param history : history for this activity in the AI (need to be inside the exerciceManager ?)
     * @param ontology : specify from which ontology to sample from
     * @returns : exerciceId
     */
    ExercicesManager.prototype.next_exercice = function (AIEngine, actID, ontology) {
        var exerciseId;
        switch (AIEngine) {
            case "zpdes":
                exerciseId = this.select_ZPDES_exercices(actID, this.history["AI"], ontology);
                break;
            case "revisionAlg":
                exerciseId = this.select_AS_exercices(actID, this.history["AI"], ontology);
                break;
            case "adaptiveTest":
            case "cnedAdaptiveTest":
                exerciseId = this.select_AT_exerice(actID, this.history["AI"], ontology);
                break;
            case "initialTest":
                var activityInfo = this.select_initialTest_exercises(this.history[AIEngine], ontology);
                return activityInfo;
        }
        return exerciseId;
    };
    ExercicesManager.prototype.select_ZPDES_exercices = function (actID, history, ontology) {
        var exo = ontology.exercices_in_act[actID];
        if (exo.length === 1) {
            // Only one exercise, no choice but to repeat it
            return exo[0];
        }
        // Check if there are exercises not yet seen in the history
        if (exo.length > history[actID].length) {
            // Filter out exercises that have already been seen
            var available_exo = exo.filter(function (x) { return !history[actID].includes(x); });
            return available_exo[Math.floor(Math.random() * available_exo.length)];
        }
        else {
            // Determine the number of exercises to exclude based on available exercises
            var excludeCount = Math.min(3, exo.length - 1);
            // Get the last `excludeCount` seen exercises
            var lastSeenExercises_1 = history[actID].slice(-excludeCount);
            // Reset history if all exercises have been seen
            history[actID] = [];
            // Filter out the last `excludeCount` seen exercises to avoid immediate repetition
            var available_exo = exo.filter(function (x) { return !lastSeenExercises_1.includes(x); });
            var selected = available_exo[Math.floor(Math.random() * available_exo.length)];
            return selected;
        }
    };
    // make selction based on ZPDES history
    ExercicesManager.prototype.select_AS_exercices = function (actID, history, ontology) {
        var exo = ontology.exercices_in_act[actID];
        exo = [exo[0], exo[1], exo[2]];
        if (exo.length === 1) {
            // Only one exercise, no choice but to repeat it
            return exo[0];
        }
        // Check if there are exercises not yet seen in the history
        if (exo.length > history[actID].length) {
            // Filter out exercises that have already been seen
            var available_exo = exo.filter(function (x) { return !history[actID].includes(x); });
            return available_exo[Math.floor(Math.random() * available_exo.length)];
        }
        else {
            // Determine the number of exercises to exclude based on available exercises
            var excludeCount = Math.min(3, exo.length - 1);
            // Get the last `excludeCount` seen exercises
            var lastSeenExercises_2 = history[actID].slice(-excludeCount);
            // Reset history if all exercises have been seen
            history[actID] = [];
            // Filter out the last `excludeCount` seen exercises to avoid immediate repetition
            var available_exo = exo.filter(function (x) { return !lastSeenExercises_2.includes(x); });
            var selected = available_exo[Math.floor(Math.random() * available_exo.length)];
            return selected;
        }
    };
    ExercicesManager.prototype.select_AT_exerice = function (actID, history, ontology) {
        var exo = ontology.exercices_in_act[actID];
        if (exo.length === 1) {
            // Only one exercise, no choice but to repeat it
            return exo[0];
        }
        // Check if there are exercises not yet seen in the history
        if (exo.length > history[actID].length) {
            // Filter out exercises that have already been seen
            var available_exo = exo.filter(function (x) { return !history[actID].includes(x); });
            return available_exo[Math.floor(Math.random() * available_exo.length)];
        }
        else {
            // Determine the number of exercises to exclude based on available exercises
            var excludeCount = Math.min(3, exo.length - 1);
            // Get the last `excludeCount` seen exercises
            var lastSeenExercises_3 = history[actID].slice(-excludeCount);
            // Reset history if all exercises have been seen
            history[actID] = [];
            // Filter out the last `excludeCount` seen exercises to avoid immediate repetition
            var available_exo = exo.filter(function (x) { return !lastSeenExercises_3.includes(x); });
            var selected = available_exo[Math.floor(Math.random() * available_exo.length)];
            return selected;
        }
    };
    ExercicesManager.prototype.select_initialTest_exercises = function (history, ontology) {
        var activityInfo = {
            moduleId: "",
            objectiveId: ontology.initialTestDatas["objectiveId"],
            activityId: ontology.initialTestDatas["activityId"],
            exerciseId: ontology.initialTestDatas["exercises"][history.length],
            isInitialTest: true,
        };
        return activityInfo;
    };
    ExercicesManager.prototype.updateHistory = function (AIEngine, actId, exerciseId) {
        if (AIEngine == "initialTest") {
            this.history[AIEngine].push(exerciseId);
        }
        else {
            this.history["AI"][actId].push(exerciseId);
        }
    };
    return ExercicesManager;
}());
exports.ExercicesManager = ExercicesManager;
